import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { ButtonBase } from "../index.tsx";
import { Fragment } from "react";

type ModalWrapperProps = {
  isOpen: boolean;
  handleCloseModal: () => void;
  isLoading?: boolean;
  title: string;
  description?: string;
  containerClass?: string;
  children: React.ReactNode;
  icon?: JSX.Element;
  disableXmark?: boolean;
  imgUrl?: string;
  descriptionWidth?: string;
  hideCrossMark?: boolean;
};

const ModalWrapper = ({
  isOpen,
  isLoading,
  title,
  description,
  containerClass,
  children,
  disableXmark,
  handleCloseModal,
  icon,
  imgUrl,
  descriptionWidth,
  hideCrossMark = false,
}: ModalWrapperProps) => {
  return (
    <Transition as={Fragment} appear show={isOpen}>
      <Dialog as="div" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-50 bg-black/25" />
        </TransitionChild>
        <div className="fixed inset-0 overflow-y-auto z-50">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              className={`min-w-max bg-white rounded-lg p-6 flex flex-col gap-3 shadow-xl ${containerClass}`}
            >
              <section className="flex relative items-center justify-between gap-8 border-b border-extraLightGray pb-2">
                <div>
                  <h1 className="text-md font-semibold max-sm:text-base text-ellipsis flex gap-2 items-center">
                    {icon}
                    {imgUrl && (
                      <img
                        src={imgUrl}
                        className="h-8 w-8 max-sm:w-4"
                        alt="img.png"
                      />
                    )}
                    {title?.charAt(0).toUpperCase() + title?.slice(1)}
                  </h1>
                  <p
                    className={`tw-sub-heading max-sm:hidden ${descriptionWidth}`}
                  >
                    {description}
                  </p>
                </div>
                {!hideCrossMark && (
                  <ButtonBase
                    className="text-subHeading"
                    icon={<XMarkIcon className="size-5" />}
                    buttonType="tertiary"
                    onClick={handleCloseModal}
                    disabled={disableXmark}
                  />
                )}
              </section>
              {isLoading ? (
                <div className="h-56 bg-lightGray rounded-lg animate-pulse" />
              ) : (
                children
              )}
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalWrapper;
